/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class Transaction {
  static async getList(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'get',
        path: 'transaction/getList',
        query
      }).then((result = {}) => {
        const { data } = result;
        return resolve({ isSuccess: true, data });
      });
    });
  }
}
